<template>
  <div
      class="result"
      v-if="resultType">
    <div class="background-primary relative">
      <img
          :src="require(`@/assets/images/investorTypes/${resultType}.png`)"
          :alt="result.name"
      />
      <div class="result__headContainer">
        <div class="result__card">
          <p class="result__title">{{ result.name }}{{ result.title }}</p>
          <div class="result__tags">
            <span
                class="result__tag"
                :class="'result__tag'+index"
                v-for="(tag, index) in result.tags"
                :key="index"
            >{{ tag }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="background-subTop">
      <div class="result__mainTitle">你的特質</div>
      <div class="result__features">
        <div
            class="result__feature"
            v-for="(feature, index) in result.features"
            :key="index"
            >
            <div
                v-for="line in feature.split('\n')"
                :key="line">
                {{ line }}
            </div>
        </div>
      </div>
    </div>
    <div>
      <div class="result__mainTitle">市場人格四象限</div>
      <div class="result__container result__quadrants">
        <img
            :src="require(`@/assets/images/quadrants/${resultType}.png`)"
            :alt="result.name"
        />
      </div>
    </div>
    <div class="result__training">
      <div class="result__container result__cardContainer">
      <div class="result__mainTitle">你的職前訓練</div>
        <ul class="result__card">
          <li
              class="result__trainingItem"
              v-for="(training, index) in result.training"
              :key="index"
          >
            <span class="result__trainingNum">{{ index + 1 }}</span>
            <p v-html="training" />
          </li>
        </ul>
      </div>
    </div>
    <div class="result__buttons">
      <button
          type="button"
          class="sub-button result__button"
          @click="restart">
        再測一次
      </button>
      <a
        class="main-button result__startButton result__button"
        href="https://productblue.page.link/test"
        @click="addLog"
      >
        設定人格去
      </a>
    </div>
  </div>
  <ProgressPage
      v-else
      :totalSeconds="waitingSeconds" />
</template>

<script>
import Vue from 'vue';
import { addELK } from '@/plugins/elk';
import ProgressPage from './ProgressPage';

const investorTypes = {
  partTimeInvestor: {
    name: '打工型',
    title: '交易者',
    tags: ['想要每週加薪', '持股週期1週以內', '適合短線交易操作'],
    features: [
      '作息有時間盯盤，性子急且果斷',
      '願意接受頻繁的買賣\n不願承受股價拉回的風險',
      '你想要拚的是「週轉率」\n在交易的過程中讓資產上升',
    ],
    training: [
      '你是來交易市場打工的，拿不到打工錢(獲利)請果斷離開！',
      '你適合速戰速決，希望1週內就知道交易結果',
      '你相信股價開始發動再去參與是最有效率的方式',
      '買賣果斷果決，風險至上，追求短期飆股獲利',
    ],
  },
  officeInvestor: {
    name: '上班族型',
    title: '交易者',
    tags: ['目標是每月加薪', '持股時間幾天~幾週', '適合週以上的波段交易操作'],
    features: [
      '工作模式允許偶爾偷看盤',
      '下單時會想較多，頻繁買賣容易覺得心累',
      '想吃到一段行情/買到飆股，幫自己當月加薪',
    ],
    training: [
      '你是來交易市場當副業上班族的，領取每個月的加薪',
      '最該重視金流 / 業績 / 題材',
      '開始看到金流發動後，再去參與追漲或是買拉回，是你相信最有效率的方式',
      '早盤過後(上午10點後)動作 或是 尾盤(1點後)會比較適合你動作的時間',
    ],
  },
  bossInvestor: {
    name: '老闆型',
    title: '交易者',
    tags: ['想要每季加薪 / 領額外獎金', '持股時間數週~數個月', '適合不盯盤週波段交易操作'],
    features: [
      '忙於本業 / 家務，一天只打開1.2次看盤軟體',
      '股價短期飆不飆是其次\n能持有優質好公司的波段才是重點',
      '願意在股價拉回時建立更好的成本\n並賦予時間等它再次發動',
    ],
    training: [
      '你是來交易市場當老闆的，願意付出時間陪你的公司成長',
      '你最該重視的是公司營收 / 公司未來展望 / 國際題材',
      '你相信股價開始休息整理時，能買入便宜的價位是最有效率的方式',
      '尾盤(下午1點後)動作會比較適合你，追求中長期波段獲利',
    ],
  },
  growthInvestor: {
    name: '成長型',
    title: '投資者',
    tags: ['想要每年多領一份年終', '持股時間數月以上', '適合巴菲特價值股長線投資 / 低買高賣'],
    features: [
      '眼光長遠，覺得短線頻繁交易成不了大氣',
      '願意去了解公司的展望及產業趨勢\n抓出大成長的潛力軌跡',
      '市場悲觀、股價大跌時\n是你感到興奮與佈局的好時機',
    ],
    training: [
      '你是投資市場裡的星探，專門找出具高度潛力、成長動能強勁的公司',
      '你最該重視的是公司基本面 / 老闆發言 / 國際產業趨勢',
      '你願意付出時間等待更好的成本，短期的股價波動與你無關',
      '你相信在公司股價被低估 / 公司被誣賴 / 市場恐慌時，買入優質公司，並陪伴一路成長，為最好的投資方式',
    ],
  },
  passiveInvestor: {
    name: '被動型',
    title: '投資者',
    tags: ['想要打造長期穩定的現金流', '持股時間數年以上', '適合固定配息、長期投資/價差'],
    features: [
      '沒時間或不知道怎麼做主動投資',
      '發現自己主動投資的績效還不如被動投資',
      '個性穩重，有能力做到長期買進持有',
    ],
    training: [
      '不需在意日常波動，不需與他人比較報酬率，只要專心將自身資產配置好即可',
      '你的持股週期以"年"為單位。你最該重視的是公司基本面 / 公司配息 / 買入成本',
      '你在市場追求的是，"最"穩定的投資，用時間複利打造長期現金流',
      '可以定期定額，但當市場低迷時，人棄我取時，更是你建立好成本的時機',
    ],
  },
};

export default {
  name: 'InvestmentTestResult',
  components: {
    ProgressPage,
  },
  props: {
    score: {
      type: Number,
      default: () => {},
    },
  },
  data() {
    return {
      waitingSeconds: 0,
      resultType: null,
    };
  },
  computed: {
    result() {
      return investorTypes[this.resultType];
    },
  },
  created() {
    setTimeout(() => {
      this.resultType = this.getResult(this.score);
      const gtmParam = this.getGTMParameter(this.resultType);
      Vue.gtm.trackEvent({
        // 自行定義的事件名稱
        event: '回傳跳轉對應人格頁面',
        // 頁面功能/分頁標題文字
        result: gtmParam,
      });
      addELK('回傳跳轉對應人格頁面', {
        Parameter: gtmParam,
      });
    }, 1000 * this.waitingSeconds);
  },
  methods: {
    addLog() {
      addELK('設定人格去', {
        Parameter: '設定人格去',
      });
    },
    restart() {
      this.$emit('restart');
    },
    getResult(score) {
      switch (score >= 0) {
        case score >= 45:
          return 'partTimeInvestor';
        case score > 30:
          return 'officeInvestor';
        case score > 15:
          return 'bossInvestor';
        case score >= 8:
          return 'growthInvestor';
        default:
          return 'passiveInvestor';
      }
    },
    getGTMParameter(resultType) {
      switch (resultType) {
        case 'partTimeInvestor':
          return 'person_Part-TimeTrader';
        case 'officeInvestor':
          return 'person_OfficeTrader';
        case 'bossInvestor':
          return 'person_BossTrader';
        case 'growthInvestor':
          return 'person_GrowthInvestor';
        case 'passiveInvestor':
          return 'person_PassiveInvestor';
        default:
          return '';
      }
    },
  },
};
</script>

<style scoped lang="css">
.result{
  padding-bottom: 88px;
  overflow: hidden;
}
.result__headContainer {
  padding-bottom:145px;
}
.result__headContainer .result__card{
  padding: 24px 0;
  position: absolute;
  bottom: -29px;
  left: 16px;
  right: 16px;
}
.result__container {
  padding: 1px 16px 32px;
}
.result__card {
  background: linear-gradient(0deg, #ffffff, #ffffff);
  border: 1px solid #2f2f2f;
  font-size: 16px;
  line-height: 24px;
  border-radius: 8px;
}
.result__card >>> b {
  font-weight: bold;
}
.result__title {
  text-align: center;
  font-size: 40px;
  line-height: 46px;
  font-weight: bold;
}
.result__tags {
  text-align: center;
  padding-top: 12px;
  margin: 0 5%;
}
.result__tag {
  font-size: 16px;
  margin: 4px;
  padding: 4px 12px;
  border-radius: 100px;
  display: inline-block;
  border: 1px solid #000;
}
.result__tag0{
  background-color: #70B8F1;
}
.result__tag1{
  background-color: #CECECE;
}
.result__tag2{
  background-color: #F3B454;
}
.result__mainTitle {
  text-align: center;
  font-size: 20px;
  line-height: 32px;
  position: relative;
  margin: 32px 0px 15px;
  display: inline-block;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 900;
}
.result__mainTitle::before,.result__mainTitle::after{
  content: '';
  display: block;
  position: absolute;
  height: 0.6px;
  background-color: #000;
  top:50%;
  width: calc(50vw - 50% - 36px);
}
.result__mainTitle::before{
  left:calc(50% - 50vw + 24px);
}
.result__mainTitle::after{
  right:calc(50% - 50vw + 24px);
}
.background-primary {
  background-color: #70B8F1;
}
.background-primaryReverse {
  background: linear-gradient(90deg, #ffb13b, #ffe5ad);
}
.background-subTop {
  padding-top: 13px;
  background-color: #70B8F1;
}
.result__training {
  background-color: #F6C856;
  padding-bottom: 32px;
}
.result__training .result__card{
  padding: 12px 16px;

}
.result__quadrants {
  padding: 0 16px 35px;
}
.result__features{
  padding:0 15px 24px;
  margin-top: -10px;
}
.result__feature{
  text-align: center;
  background-color:  rgba(255,255,255,0.6);
  font-size: 16px;
  line-height: 24px;
  padding: 12px 0;
  margin: 8px 0;
  border: 1px #000 solid;
  border-radius: 10px;
}
.result__trainingNum {
  display: flex;
  width: 20px;
  height: 20px;
  line-height: 22px;
  text-align: center;
  border-radius: 50%;
  background-color: #222222;
  color: #fff;
  min-width: 20px;
  margin-right: 8px;
  margin-top: 2px;
  justify-content: center;
  align-items: center;
}
.result__trainingItem:not(:last-child) {
  padding-bottom: 8px;
  border-bottom: 1px dotted #000;
}
.result__trainingItem:not(:first-child) {
  padding-top: 8px;
}
.result__trainingItem {
  display: flex;
}
.result__buttons {
  padding: 24px 0;
  width: 100%;
  background-color: #f8f8f8;
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: center;
  z-index: 10;
}

.result__button {
  width: 28%;
  font-size: 16px;
  border: none;
  margin: 0 6px;
}
.result__startButton {
  width: 56%;
}

@media screen and (min-width: 480px) {
  .result__buttons {
    max-width: 480px;
  }
}
</style>
